import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ReservaService } from '../../../../core/services/reserva.service';
import { ReservasTableComponent } from '../../../../core/components/reservas-table/reservas-table.component';
import { StepReservaComponent } from '../../../../core/components/step/step-reserva/step-reserva.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { FormsModule } from '@angular/forms';
import { Reserva } from '../../../../core/interfaces/utilidades/reservas.interface';
import { NumReciboComponent } from '../../../../core/components/num-recibo/num-recibo.component';
import {EditarReservaComponent} from '../../../../core/components/editar-reserva/editar-reserva.component';

@Component({
  selector: 'app-reserva',
  templateUrl: './reservas.component.html',
  imports: [
    ReservasTableComponent,
    NzButtonComponent,
    NzIconDirective,
    NzModalModule,
    FormsModule,
    NumReciboComponent,
    EditarReservaComponent,
  ],
  styleUrls: ['./reservas.component.css']
})
export class ReservasComponent implements OnInit {
  reservas: any[] = [];
  isReciboModalVisible: boolean = false;
  isEditReservaModalVisible: boolean = false;
  numRecibo: string = '';
  reservaSeleccionada: any;

  constructor(
    private reservaService: ReservaService,
    private message: NzMessageService,
    private modal: NzModalService
  ) {}

  ngOnInit(): void {
    this.loadReservas();
  }

  loadReservas(): void {
    this.reservaService.getReservasSimplificadas().subscribe((reservas: any[]) => {
      this.reservas = reservas;
    });
  }

  showReservaForm(): void {
    const modalRef = this.modal.create({
      nzTitle: 'Nueva Reserva',
      nzContent: StepReservaComponent,
      nzFooter: null,
      nzWidth: '650px'
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        console.log('Reserva creada:', result);
        this.loadReservas();
      } else {
        console.log('El modal fue cerrado sin cambios.');
        this.loadReservas(); // Asegúrate de llamar a loadReservas aquí también
      }
    });
  }

  onEditReserva(reserva: any): void {
    const reservaId = reserva.id;
    this.reservaSeleccionada = reservaId;
    this.isEditReservaModalVisible = true;
  }

  handleCancelEditReservaModal(): void {
    this.isEditReservaModalVisible = false;
  }

  submitEditReservaForm(): void {
    this.loadReservas();
    this.isEditReservaModalVisible = false;
  }

  onDeleteReserva(row: Reserva): void {
    this.reservaService.deleteReserva(row.id).subscribe(
      () => {
        this.loadReservas();
        this.message.success('Reserva eliminada exitosamente');
      },
      (error) => {
        this.message.error('Error al eliminar la reserva');
        console.error('Error al eliminar la reserva', error);
      }
    );
  }

  onCheckReserva(reserva: any): void {
    this.reservaSeleccionada = reserva;
    this.numRecibo='';
    this.isReciboModalVisible = true;
  }

  submitReciboForm(): void {
    if (this.numRecibo) {
      this.reservaService.updateNumRecibo(this.reservaSeleccionada.id, this.numRecibo).subscribe(
        () => {
          const nuevoIdEstado = this.reservaSeleccionada.estado.id_estado === 1 ? 2 : 1;
          this.reservaService.updateEstadoReserva(this.reservaSeleccionada.id, nuevoIdEstado).subscribe(
            (reservaActualizada) => {
              const index = this.reservas.findIndex(r => r.id === reservaActualizada.id);
              if (index !== -1) {
                this.reservas[index].estado = reservaActualizada.estado;
              }
              this.loadReservas();
              this.message.success('Estado cambiado a Pagado y recibo actualizado');
            },
            (error) => {
              this.message.error('Error al cambiar el estado');
              console.log(error);
            }
          );
        },
        (error) => {
          this.message.error('Error al actualizar el número de recibo');
          console.log(error);
        }
      );
      this.isReciboModalVisible = false;
    } else {
      this.message.error('Por favor, ingrese un número de recibo válido');
    }
  }

  handleCancelReciboModal(): void {
    this.isReciboModalVisible = false;
  }
}
